import { FjellsportMapWrapper } from 'components/eventView/pages/MapWrappers/FjellsportMapWrapper';
import { DialogOpenEventView } from 'pages/custom/shared/CustomMapPage/DialogOpenEventView';

export const FjellsportFestivalPage = (): JSX.Element => {
    return (
        <FjellsportMapWrapper mapId={'aa078a07-88f1-4c57-837a-64b9dd178102'} automaticHeader={true}>
            <DialogOpenEventView link="https://app.mapheim.com/event/fjellsport/map" />
        </FjellsportMapWrapper>
    );
};
